// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from "./environment-interface";

export const environment:Environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyApHVXMc-iJ5TuYxa_dhSC_yzPzBy8TY-A",
    authDomain: "studia-c1386.firebaseapp.com",
    projectId: "studia-c1386",
    storageBucket: "studia-c1386.appspot.com",
    messagingSenderId: "1084858432560",
    appId: "1:1084858432560:web:6560b4583fae6c5b2441f5",
    measurementId: "G-JL46KP56KY"
  },
  apiUrl: '/api/',
  appUrl: '/app/',
  netCoreApiUrl: 'https://a2nservices.azurewebsites.net/api/',
  paymentsApiUrl: 'https://studiapp-pay.azurewebsites.net/',
  authApiUrl: 'https://a2nsecurity.azurewebsites.net/api/',
  hmr: false,
  baseUrl: '',
  loginUrl: '',
  refreshUrl: '',
  stripeKey: 'pk_live_51JFZLgCXGa1vgEMZgEQl9qODRD124aXVe70faKvXA9sRkBgcXESSfubSgBYcL3fZQuJVtEnAuTvF1JcqCh6MwIwa00VPLykGrC',
  // --- PRO endpoints ---
  nenomedCloudUrl: 'https://nenomedcloud.azurewebsites.net/',
  nenomedApiUrl: 'https://nenomedapi.azurewebsites.net/',
  nenomedIAUrl: 'https://a2nservices.azurewebsites.net/',
  // nenomedCloudUrl: 'http://localhost:50875/',
  // nenomedApiUrl: 'https://localhost:7275/',
  // nenomedIAUrl: 'https://a2nservices.azurewebsites.net/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
